import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { finalize } from 'rxjs';
import { DriverCommercialIntentViewModel } from '../../../driver/models/driver-commercial-intent-view.model';
import { DriverCommercialIntentStatusType } from '../../../driver/models/enums/driver-commercial-intent-status-type.enum';
import { DriverCommercialIntentService } from '../../../driver/services/driver-commercial-intent.service';
import { BaseComponent } from '../../../shared/base-components/base.component';
import { AuthService } from '@max/auth/services/auth.service';
import { MvdModalService } from '@max/shared/services/modal/mvd-modal.service';
import { DriverCommercialIntentHistoryModalComponent, DriverCommercialIntentHistoryModalContext } from './driver-commercial-intent-history-modal.component';

@Component({
    selector: 'commercial-intent-table',
    templateUrl: './commercial-intent-table.html'
})
export class CommercialIntentTableComponent extends BaseComponent implements OnInit, OnChanges {
    /**
     * The customer number id.
     */
    @Input() public customerNumberId: number;

    /**
     * The control flag for editing and deleting.
     */
    @Input() public actionsEnabled: boolean;

    /**
     *  Flag for editing Self Certs
     */
    public canEditMedicalReviewSelfCert: boolean;

    /**
     * The current driver commercial intent.
     */
    public currentDriverCommercialIntent: DriverCommercialIntentViewModel;

    /**
     * The driver commercial intent history.
     */
    public driverCommercialIntentHistory: DriverCommercialIntentViewModel[] = [];

    /**
     * The driver commercial intent status type enum.
     */
    private driverCommercialIntentStatusTypeEnum: DriverCommercialIntentStatusType = new DriverCommercialIntentStatusType();

    constructor(
        private modalService: MvdModalService,
        private driverCommercialIntentService: DriverCommercialIntentService,
        private authService: AuthService
    ) {
        super();
    }

    /**
     * Handles the ng on init.
     */
    public ngOnInit(): void {
        if (this.customerNumberId) {
            this.loadDriverCommercialIntentHistory();
        }

        this.canEditMedicalReviewSelfCert = this.authService.hasACSTransactionClaimEx(this.authService.acsTransactionClaim, 'EditMedicalReviewSelfCert');

    }

    /**
     * Handles the on changes event.
     * @param changes The changes to the component.
     */
    public ngOnChanges(changes: SimpleChanges): void {
        if (changes.customerNumberId) {
            this.loadDriverCommercialIntentHistory();
        }
    }

    /**
     * loads the driver commercial intent history for the customer.
     */
    public loadDriverCommercialIntentHistory(): void {
        this.driverCommercialIntentService.getCustomerDriverCommercialIntentHistory(this.customerNumberId)
            .subscribe({
                next: response => {
                    this.driverCommercialIntentHistory = response ?? [];
                    this.currentDriverCommercialIntent = this.driverCommercialIntentHistory.find(x => x.driverCommercialIntentStatusTypeId == this.driverCommercialIntentStatusTypeEnum.Active.id);
                },
                error: errors => this.handleValidationResult(errors)
            });
    }

    public showHistory(): void {
        const data = new DriverCommercialIntentHistoryModalContext(
            this.driverCommercialIntentHistory.filter(x => x.driverCommercialIntentStatusTypeId != this.driverCommercialIntentStatusTypeEnum.Active.id));
        this.modalService.open(DriverCommercialIntentHistoryModalComponent, data);
    }

    /**
     * Removes the self certification.
     * @param driverCommercialIntentId The driver commercial intent id.
     */
    public removeSelfCertification(driverCommercialIntentId: number): void {
        this.driverCommercialIntentService.remove(driverCommercialIntentId)
            .pipe(finalize(() => this.loadDriverCommercialIntentHistory()))
            .subscribe();
    }

}
